class ProductMenu extends HTMLElement {
  constructor() {
    super();

    this.groupHeads = this.querySelectorAll(".product-menu__group-head");

    this.groupHeads.forEach((groupHead) => {
      groupHead.addEventListener("click", this._handleGroupClick.bind(this));
    });

    window.addEventListener("click", this._handleClickOutside.bind(this));

    this.anchors = this.querySelectorAll("a");

    this.anchors.forEach((anchor) => {
      anchor.addEventListener(
        "click",
        this._handleRemoveOverflowHidden.bind(this)
      );
    });
  }

  _handleRemoveOverflowHidden() {
    // console.log("LE CLICK");
    document.documentElement.classList.remove("overflow-hidden");
  }

  _handleGroupClick(e) {
    e.preventDefault();
    if (e.target.parentElement.classList.contains("is--selected")) {
      e.target.parentElement.classList.remove("is--selected");
      return;
    } else if (this.querySelector(".is--selected")) {
      this.querySelector(".is--selected").classList.remove("is--selected");
      e.target.parentElement.classList.add("is--selected");
      return;
    } else {
      e.target.parentElement.classList.add("is--selected");
    }
  }

  _handleClickOutside(e) {
    if (this.querySelector(".is--selected") && !this.contains(e.target)) {
      this.querySelector(".is--selected").classList.remove("is--selected");
    }
  }

  connectedCallback() {}
}

customElements.define("product-menu", ProductMenu);
